export enum PAvatarType {
  ICON = 'icon',
  MONOGRAM = 'monogram',
  AVATAR = 'avatar',
}

export enum PAvatarSize {
  EXTRA_SMALL = 'extra-small',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
